import formatPhoneNumber from "utils/formatPhone"
import * as Yup from "yup"

// Keep this accepted format aligned with the board-member update API.
const phonePattern =
  /^(?:\+?1[\s.-]?)?(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/

const normalizeMemberPhone = (value) => {
  if (typeof value !== "string" || !phonePattern.test(value.trim())) {
    return null
  }
  return value.replace(/\D/g, "").slice(-10)
}

export const getPhoneInputValue = (phone) =>
  formatPhoneNumber(normalizeMemberPhone(phone)) || phone || ""

export const memberPhoneSchema = (initialPhone, editingMember) =>
  Yup.string().test(
    "member-phone",
    "Enter a valid 10-digit US phone number",
    (value) =>
      (editingMember && value === initialPhone) ||
      !value?.trim() ||
      Boolean(normalizeMemberPhone(value))
  )

export const getPhonePayload = (phone, initialPhone, editingMember) => {
  if (editingMember && phone === initialPhone) return {}
  // The create endpoint adds +1; updates accept the same national digits.
  return { phone: normalizeMemberPhone(phone) || (editingMember ? null : "") }
}
